module.exports = __webpack_public_path__ + "img/logo_elixir.1b5b5af0.png";